import { DecoratedFormProps, FieldArray, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { Dispatch } from 'react';
import { maxLength, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import styles from './assets/program-book-form.module.scss';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import {
    asyncPersistProgramBookAnswer,
    asyncPersistProgramBookAnswerOfTarget,
    getProgramBooks,
} from 'src/store/actions/program-book-actions';
import RenderSectionArray from './RenderSectionArray';

export interface ProgramBookAnswerFormData {
    id: string;
    orderId: string;
    values: any;
    title: string;
    cpt: string;
    isEvaluation: boolean;
    seanceId: number | null;
    answer: number | string;
    isSkip: any;
}
interface ProgramBookAnswerFormProps {
    setLoader: (it: boolean) => void;
    programBookId?: any;
    studentId: any;
    setDataChanged: (it: []) => void;
    setIsDataChanged: (it: boolean) => void;
    setIsChangeValue: (it: boolean) => void;
    setIsManualChangeValue: (it: boolean) => void;
    setTargetManualChangeValue: (it: string) => void;
    inProgressAnswers: any;
    isChangeValue: any;
    isManualChangeValue: any;
    targetManualChangeValue: any;
    dataBookAnswers: any;
}

type InjectedProps = InjectedFormProps<ProgramBookAnswerFormData, ProgramBookAnswerFormProps>;

const validators: Validators<ProgramBookAnswerFormData> = {
    title: [maxLength({ max: 255 })],
};

const ProgramBookAnswerForm: React.FunctionComponent<InjectedProps & ProgramBookAnswerFormProps> = ({
    handleSubmit,
    error,
    dirty,
    submitting,
    setIsManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    isManualChangeValue,
    inProgressAnswers,
    programBookId,
}: InjectedProps & ProgramBookAnswerFormProps) => {
    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form, styles.treeview)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="seanceId"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />

            <FieldArray
                setTargetManualChangeValue={setTargetManualChangeValue}
                targetManualChangeValue={targetManualChangeValue}
                setIsManualChangeValue={setIsManualChangeValue}
                isManualChangeValue={isManualChangeValue}
                name="values"
                component={RenderSectionArray}
                programBookId={programBookId}
            />

            <div className={classNames(styles.actions, styles.actionsButtonContainer)}>
                <button
                    type="submit"
                    disabled={!dirty || submitting || inProgressAnswers}
                    className={classNames('btn', styles.btnSave)}
                >
                    <FontAwesomeIcon icon={faSave} /> {'Save the answers'}
                </button>
            </div>
        </form>
    );
};
//let timeout: any = null;

export default reduxForm<ProgramBookAnswerFormData, ProgramBookAnswerFormProps>({
    form: 'program-book',
    validate(
        values: ProgramBookAnswerFormData,
        props: DecoratedFormProps<ProgramBookAnswerFormData, ProgramBookAnswerFormProps, string>,
    ): FormErrors<ProgramBookAnswerFormData, string> {
        const errors: FormErrors<ProgramBookAnswerFormData, string> = {};
        return errors;
    },
    onSubmit: async (data: ProgramBookAnswerFormData, dispatch: Dispatch<any>, props: ProgramBookAnswerFormProps) => {
        props.setLoader(true);

        if (!props.inProgressAnswers) {
            props.setLoader(true);

            await asyncPersistProgramBookAnswer(data, dispatch);
            await dispatch(
                getProgramBooks({
                    filters: {
                        //'orderEntity.id': seance?.occasion?.orderEntity?.id,
                        'student.id': props.studentId,
                    },
                }),
            );

            props.setIsChangeValue(false);
            props.setIsManualChangeValue(false);
            props.setTargetManualChangeValue('');
        }
    },
    onChange: async (
        values: Partial<ProgramBookAnswerFormData>,
        dispatch: Dispatch<any>,
        props: any,
        previousValues: Partial<ProgramBookAnswerFormData>,
    ) => {
        if (values?.values?.length) {
            if (props.inProgressAnswers && props.isManualChangeValue) {
                props.setIsChangeValue(true);
                props.setLoader(false);
            } else {
                if (props.isManualChangeValue) {
                    props.setLoader(false);
                    props.setIsChangeValue(false);

                    if (props.targetManualChangeValue) {
                        asyncPersistProgramBookAnswerOfTarget(values, props.targetManualChangeValue, dispatch);
                    } else {
                        asyncPersistProgramBookAnswer(values, dispatch);
                    }
                    props.setIsChangeValue(false);
                    props.setIsManualChangeValue(false);
                    props.setTargetManualChangeValue('');
                }
            }
        }
    },

    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<ProgramBookAnswerFormData, ProgramBookAnswerFormProps, string>,
    ) {
        toast.success(`Program Answers was successfully saved.`);
    },
    onSubmitFail(errors: { _error: string }) {
        if (errors?._error) {
            toast.error(errors._error);
        }
    },
})(ProgramBookAnswerForm);
